/* eslint-disable react/prop-types */
import ModalUI from "components/ModalUI";
import * as React from "react";

export default function MissionDetailModal({ modalInfo, closeModal }) {
    const data = modalInfo.item
    return (
        <ModalUI open={modalInfo.state} handleClose={closeModal} style={{ minWidth: "600px", fontSize: 16 }}>
            <p style={{ marginBottom: 5 }}>توضیحات: {data.description}</p>
            <p style={{ marginBottom: 5 }}>امتیاز: {data.gem}</p>
            <p style={{ marginBottom: 5 }}>نیاز به تایید: {data.need_to_approve ? "بله" : "خیر"}</p>
            <p style={{ marginBottom: 5 }}>هدف: {data.target}</p>
            <p style={{ marginBottom: 5 }}>درصد نشان: {data.percent_of_badge * 100} درصد</p>
        </ModalUI>
    );
}
